export default class ExternalTrackers {
    static initGAds() {
        const elId = 'goog-ads-script'
        const tagManagerId = 'GTM-N43BNTH'
        if (!document.getElementById(`${elId}`)) {
            window.dataLayer = window.dataLayer || []

            window.dataLayer.push({
                'gtm.start': new Date().getTime(),
                event: 'gtm.js',
            })

            const script = document.createElement('script')
            script.async = true
            script.src = `https://www.googletagmanager.com/gtm.js?id=${tagManagerId}`
            script.id = elId
            document.body.appendChild(script)
        }
    }
}
